import React from "react";
import "./Deposit.scss";
import demoQR from "../../../../../../assets/images/QR.png";
import { CheckCircleIcon, CopyIcon } from "../../../../../../assets/icons/svgicons";
import { STATUS_CODE } from "../../../../../../utils/constants";
import { useEffect } from "react";
import {
  generateAccountAction,
  getUserCoinListAction,
  getDepositHistoryAction,
} from "../../../../../../features/user/userSlice";
import { useState } from "react";
import { useDispatch } from "react-redux";
import CopyBtn from "../../../../../common/CopyBtn/CopyBtn";
import { setSelectedCoinId } from "../../../../../../features/user/userSlice";
import Select from "../../../../../common/Formik/Select/Select";
import selectStyles from "../../../../../common/Formik/Select/Select.module.scss";

const Deposit = () => {
  const [showModal, setShowModal] = useState(false);
  const [depositData, setDepositData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);

  const dispatch = useDispatch();
  const [selectedCoin, setSelectedCoin] = useState(null);
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [generatedAddress, setGeneratedAddress] = useState("");
  const [addressLoading, setAddressLoading] = useState(false);
  const [coinOptions, setCoinOptions] = useState([]);

  const fetchCoinOptions = async () => {
    try {
      const response = await dispatch(getUserCoinListAction());
      if (response.data.status === STATUS_CODE.successful) {
        const array = [];
        const newData = response.data.data.coinList;
        newData?.map((coin) => {
          array.push({
            value: coin.id,
            label: coin.coin_symbol,
            networkdetails: coin.networkDetail,
          });
        });
        setCoinOptions(array);

        // Set default coin and network
        if (array.length > 0) {
          const defaultCoin = array[0]; // Set default to the first coin in the list
          setSelectedCoin(defaultCoin);
          const defaultNetwork = defaultCoin.networkdetails[0];
          setSelectedNetwork({
            value: defaultNetwork.id,
            label: defaultNetwork.parent_coin_name,
          });
          generateAddress(defaultCoin.label, defaultNetwork.parent_coin_name);
        }
      }
    } catch (error) {
      console.error("Error fetching coin options:", error);
    }
  };

  useEffect(() => {
    fetchCoinOptions();
    // generateAddress(selectedCoin?.label, selectedNetwork?.label);
  }, []);

  //   useEffect(() => {
  //     if (show) {
  //       generateAddress(selectedCoin?.label, selectedNetwork?.label);
  //     }
  //   }, [show]);

  const handleCoinChange = (selectedCoin) => {
    setSelectedCoin(selectedCoin);
    // depositHistory();

    const newDetails = selectedCoin?.networkdetails;
    const networks = newDetails.map((network) => ({
      value: network.id,
      label: network.parent_coin_name,
    }));

    setSelectedNetwork(networks[0]); // Automatically select the first network
    setGeneratedAddress(""); // Clear the previous address
    generateAddress(selectedCoin.label, networks[0].label); // Generate address for the selected coin and default network
  };

  const generateAddress = async (coinLabel, networkLabel) => {
    if (!coinLabel || !networkLabel) {
      return;
    }

    setAddressLoading(true);

    try {
      const response = await dispatch(
        generateAccountAction({
          coin: coinLabel,
          netWork: networkLabel,
        })
      );

      if (response.data.status === STATUS_CODE.successful) {
        const address = response.data.data;
        setGeneratedAddress(address);
      }
    } catch (error) {
      console.error("Error generating address:", error);
    } finally {
      setAddressLoading(false);
    }
  };

  const depositHistory = async () => {
    setLoading(true);
    try {
      const response = await dispatch(
        getDepositHistoryAction({
          page: page,
          limit: 5,
          coinId: selectedCoin?.value,
        })
      );
      if (response.data.status === STATUS_CODE.successful) {
        setDepositData(response.data.data.data.depositlist);
      }
    } catch (error) {
      setError("Error fetching deposit history.");
      console.error("Error fetching deposit history:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedCoin) {
      dispatch(setSelectedCoinId(selectedCoin.value)); // Dispatch action to update store
      // generateAddress(selectedCoin.label, selectedNetwork?.label);
    }
  }, [selectedCoin]);
  return (
    <>
      <div className="deposit">
        <div className="deposit_in">
          <div className="left_inner">
            <div className="inner_select">
              {coinOptions.length > 0 && (
                <Select
                  variant='xlarge_height'
                  className='select_time'
                  label="Select Coin"
                  options={coinOptions}
                  value={selectedCoin}
                  onChange={handleCoinChange}
                  isSearchable={false}
                // defaultValue={Options[0]}
                // onChange={(selectedOption) =>
                //   handleFilterChange("transactionType", selectedOption?.value)
                // }
                />
              )}
            </div>
            <div className="inner_select">
              {selectedNetwork && (
                <div
                  className={`${selectStyles.select} select_time`}
                  data-variant="xlarge_height"
                >
                  <label>Network</label>
                  <div className={selectStyles.staticReadonlyControl}>
                    <h5 className={selectStyles.staticReadonlyValue}>
                      {selectedNetwork.label}
                    </h5>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="right_inner">
            <h2>Address</h2>
            <div className="qr_img">
              <img src={generatedAddress.qrCode} alt="" />
            </div>
            <div className="address_pera">
              <p title="0xE509823c7cf6a6Da0b8AA328eDe59A3088F90B42">
                {generatedAddress.address}
              </p>
              <button>
                {/* <CopyIcon /> */}
                <CopyBtn text={generatedAddress.address} />{" "}
                {/* {generatedAddress.address} */}
              </button>
            </div>
          </div>
        </div>
        <ul className="list_deposit">
          <li><span><CheckCircleIcon /></span> Please send coins to this address.</li>
          <li><span><CheckCircleIcon /></span> Minimum Network Confirmations: 6 (Usually takes ~30 mins)</li>
        </ul>
      </div >
    </>
  );
};

export default Deposit;
